export default "__VITE_ASSET__DOP_98wl__"